import { Box, Grid, Paper } from "@mui/material";
import MonthSelector from "../components/MonthSelector";
import ReportLeft from "../components/reports/ReportLeft";
import ReportRight from "../components/reports/ReportRight";
import ReportList from "../components/reports/ReportList";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";

const Report = () => {
  const { isLoggedIn } = useSelector((state: RootState) => state.app);

  if (!isLoggedIn) {
    return (
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }} sx={{ textAlign: "center" }}>
          <Box sx={{ position: "relative", display: "inline-block" }}>
            <img
              src="/images/samples/month_selector.svg"
              alt="SampleOfPiGraph"
              style={{ width: "500px", height: "90", filter: "blur(1px)" }}
            />
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "white",
                fontWeight: "bold",
                fontSize: "1.5rem",
                textShadow: "0 1px 4px rgba(0, 0, 0, 0.8)",
              }}
            >
              Sample
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }} sx={{ minWidth: 0 }}>
          <Box sx={{ position: "relative" }}>
            <img
              src="/images/samples/expense_pie_graph.svg"
              alt="SampleOfPieGraph"
              style={{ width: "100%", height: "auto", filter: "blur(1px)" }}
            />
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "white",
                fontWeight: "bold",
                fontSize: "1.5rem",
                textShadow: "0 1px 4px rgba(0, 0, 0, 0.8)",
              }}
            >
              Sample
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 8 }} sx={{ minWidth: 0 }}>
          <Box sx={{ position: "relative" }}>
            <img
              src="/images/samples/expense_bar_chart.svg"
              alt="SampleOfBarGraph"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "400px",
                filter: "blur(1px)",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "white",
                fontWeight: "bold",
                fontSize: "1.5rem",
                textShadow: "0 1px 4px rgba(0, 0, 0, 0.8)",
              }}
            >
              Sample
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
          <Box sx={{ position: "relative" }}>
            <img
              src="/images/samples/transaction_hist.svg"
              alt="HistoryOfTransaction"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "400px",
                filter: "blur(1px)",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "white",
                fontWeight: "bold",
                fontSize: "1.5rem",
                textShadow: "0 1px 4px rgba(0, 0, 0, 0.8)",
              }}
            >
              Sample
            </Box>
          </Box>
        </Grid>
      </Grid>
    );
  }
  // console.log("Report:transactions:", transactions);
  const commonPaperStyle = {
    height: { xs: "auto", md: "400px" },
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  };
  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
        <MonthSelector />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }} sx={{ minWidth: 0 }}>
        <Paper sx={commonPaperStyle}>
          <ReportLeft />
        </Paper>
      </Grid>
      <Grid size={{ xs: 12, md: 8 }} sx={{ minWidth: 0 }}>
        <Paper sx={commonPaperStyle}>
          <ReportRight />
        </Paper>
      </Grid>
      <Grid size={{ xs: 12 }} sx={{ minWidth: 0 }}>
        <ReportList />
      </Grid>
    </Grid>
  );
};

export default Report;
